import { MIN_SIDEBAR_WIDTH, useUIStore } from "../store/uiStore";
import { PaneResizeHandle } from "./PaneResizeHandle";

interface SidebarResizeHandleProps {
  width: number;
  maxWidth: number;
}

/** Pointer and keyboard resizing for the trip sidebar's right edge. */
export function SidebarResizeHandle({
  width,
  maxWidth,
}: SidebarResizeHandleProps) {
  const setSidebarWidth = useUIStore((state) => state.setSidebarWidth);

  return (
    <PaneResizeHandle
      width={width}
      minWidth={MIN_SIDEBAR_WIDTH}
      maxWidth={maxWidth}
      onResize={setSidebarWidth}
      label="Resize sidebar"
      title="Drag or use arrow keys to resize the sidebar"
      valueText={`${width} pixels`}
      className="group absolute inset-y-0 -right-2 z-20 flex w-4 cursor-col-resize touch-none items-center justify-center focus:outline-none"
      gripClassName="h-10 w-1 rounded-full bg-primary opacity-0 transition-opacity group-hover:opacity-60 group-focus:opacity-100"
      stopClickPropagation
    />
  );
}
